import {Presenter} from '../../support/with_presenter';
import {TrainingPlan} from '../../models/TrainingPlan';

export interface TrainingPlanProvider {
    get(): Promise<TrainingPlan[]>;
}

export class TrainingPlanSearchModalPresenter implements Presenter {
    public loading: boolean = true;
    public error: boolean = false;
    public trainingPlans: TrainingPlan[] = [];

    private selection: number[] = [];

    constructor(
        private onSubmit: (trainingPlans: TrainingPlan[]) => void,
        private onDismissListener: () => void,
        private trainingPlanProvider: TrainingPlanProvider,
    ) {}

    public async mount(): Promise<void> {
        try {
            this.trainingPlans = await this.trainingPlanProvider.get();
        } catch (e) {
            this.error = true;
        } finally {
            this.loading = false;
        }
    }

    public unmount(): void {
        /* Noop */
    }

    public isSelected(trainingPlan: TrainingPlan) {
        return this.selection.indexOf(trainingPlan.id) !== -1;
    }

    public onTrainingPlanClick(trainingPlan: TrainingPlan) {
        if (this.isSelected(trainingPlan)) {
            this.selection = this.selection.filter(
                (selectedTrainingPlanId) => selectedTrainingPlanId !== trainingPlan.id,
            );
        } else {
            this.selection = [...this.selection, trainingPlan.id];
        }
    }

    public onAddClick() {
        this.onSubmit(this.trainingPlans.filter((trainingPlan) => this.selection.indexOf(trainingPlan.id) !== -1));
        this.selection = [];
    }

    public onDismiss() {
        this.onDismissListener();
        this.selection = [];
    }
}
